import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSiteFilter } from '../actions/filters';
import equals from 'ramda/src/equals';
import { ApplicationState } from '../reducers';

const useSiteFilter = () => {
  const dispatch = useDispatch();

  const selectedSiteFilters = useSelector<ApplicationState, number[]>(
    ({ filters }) => {
      return filters.sites;
    },
    equals
  );

  const setFilter = useCallback(
    (updatedSiteIds: number[]) => {
      return dispatch(setSiteFilter(updatedSiteIds));
    },
    [dispatch]
  );

  const isSiteFilterActive = selectedSiteFilters.length > 0;

  return {
    setFilter,
    selectedSiteFilters,
    isSiteFilterActive
  };
};

export default useSiteFilter;
